import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, Typography } from '@mui/material';

function LabelComponent({ children, typographyProps = {}, sx = {}, isRequired = false, endAdornment, }) {
    if (!children) {
        return null;
    }
    return (jsxs(LabelWrapper, { sx: sx, children: [typeof children === "string" ? (jsx(Typography, Object.assign({ variant: "h7" }, typographyProps, { children: children }))) : (children), isRequired ? jsx(AsteriskWrapper, { sx: typographyProps, children: "*" }) : null, endAdornment] }));
}
const LabelWrapper = styled("div")(({ theme }) => ({
    color: theme.palette.text.high,
    display: "flex",
    flexWrap: "nowrap",
    alignSelf: "stretch",
    alignItems: "center",
    gap: theme.spacing(0.5),
}));
const AsteriskWrapper = styled("span")(({ theme }) => (Object.assign({ color: theme.palette.failure.main }, theme.typography.h7)));

export { LabelComponent };
//# sourceMappingURL=LabelComponent.js.map
